import { ExceptionsService } from 'libjs-pdcore/exceptions';

interface ErrorInfo {
  readonly sagaStack: string;
}

type ErrorCallback = (error: Error, { sagaStack }: ErrorInfo) => void;

let errorCallback: ErrorCallback | undefined;

export function setSagaErrorCallback(callback: ErrorCallback) {
  errorCallback = callback;
}

export function captureSagaError(error: Error, { sagaStack }: ErrorInfo): void {
  ExceptionsService.captureException(error, {
    extra: {
      sagaStack,
    },
  });

  errorCallback?.(error, { sagaStack });
}
